/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { adminRemoteSessionsCreateGlobalClient } from "../funcs/adminRemoteSessionsCreateGlobalClient.js";
import { adminRemoteSessionsCreateGlobalIssuer } from "../funcs/adminRemoteSessionsCreateGlobalIssuer.js";
import { adminRemoteSessionsDeleteGlobalClient } from "../funcs/adminRemoteSessionsDeleteGlobalClient.js";
import { adminRemoteSessionsDeleteGlobalIssuer } from "../funcs/adminRemoteSessionsDeleteGlobalIssuer.js";
import { adminRemoteSessionsFetchGlobalIssuerMetadata } from "../funcs/adminRemoteSessionsFetchGlobalIssuerMetadata.js";
import { adminRemoteSessionsGetGlobalClient } from "../funcs/adminRemoteSessionsGetGlobalClient.js";
import { adminRemoteSessionsGetGlobalIssuer } from "../funcs/adminRemoteSessionsGetGlobalIssuer.js";
import { adminRemoteSessionsGetGlobalIssuerDuplicatePreflight } from "../funcs/adminRemoteSessionsGetGlobalIssuerDuplicatePreflight.js";
import { adminRemoteSessionsGetGlobalIssuerMigratePreflight } from "../funcs/adminRemoteSessionsGetGlobalIssuerMigratePreflight.js";
import { adminRemoteSessionsListGlobalClients } from "../funcs/adminRemoteSessionsListGlobalClients.js";
import { adminRemoteSessionsListGlobalIssuerConvergenceCandidates } from "../funcs/adminRemoteSessionsListGlobalIssuerConvergenceCandidates.js";
import { adminRemoteSessionsListGlobalIssuers } from "../funcs/adminRemoteSessionsListGlobalIssuers.js";
import { adminRemoteSessionsMigrateToGlobalIssuer } from "../funcs/adminRemoteSessionsMigrateToGlobalIssuer.js";
import { adminRemoteSessionsRefreshGlobalIssuerMetadata } from "../funcs/adminRemoteSessionsRefreshGlobalIssuerMetadata.js";
import { adminRemoteSessionsUpdateGlobalClient } from "../funcs/adminRemoteSessionsUpdateGlobalClient.js";
import { adminRemoteSessionsUpdateGlobalIssuer } from "../funcs/adminRemoteSessionsUpdateGlobalIssuer.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GlobalRemoteSessionIssuer } from "../models/components/globalremotesessionissuer.js";
import { IssuerMigratePreflight } from "../models/components/issuermigratepreflight.js";
import { MigrateRemoteSessionIssuerResult } from "../models/components/migrateremotesessionissuerresult.js";
import { RemoteSessionClient } from "../models/components/remotesessionclient.js";
import { RemoteSessionIssuer } from "../models/components/remotesessionissuer.js";
import { RemoteSessionIssuerDraft } from "../models/components/remotesessionissuerdraft.js";
import { RemoteSessionIssuerDuplicatePreflight } from "../models/components/remotesessionissuerduplicatepreflight.js";
import { RemoteSessionIssuerRefresh } from "../models/components/remotesessionissuerrefresh.js";
import {
  CreateGlobalRemoteSessionClientRequest,
  CreateGlobalRemoteSessionClientSecurity,
} from "../models/operations/createglobalremotesessionclient.js";
import {
  CreateGlobalRemoteSessionIssuerRequest,
  CreateGlobalRemoteSessionIssuerSecurity,
} from "../models/operations/createglobalremotesessionissuer.js";
import {
  DeleteGlobalRemoteSessionClientRequest,
  DeleteGlobalRemoteSessionClientSecurity,
} from "../models/operations/deleteglobalremotesessionclient.js";
import {
  DeleteGlobalRemoteSessionIssuerRequest,
  DeleteGlobalRemoteSessionIssuerSecurity,
} from "../models/operations/deleteglobalremotesessionissuer.js";
import {
  FetchGlobalRemoteSessionIssuerMetadataRequest,
  FetchGlobalRemoteSessionIssuerMetadataSecurity,
} from "../models/operations/fetchglobalremotesessionissuermetadata.js";
import {
  GetGlobalRemoteSessionClientRequest,
  GetGlobalRemoteSessionClientSecurity,
} from "../models/operations/getglobalremotesessionclient.js";
import {
  GetGlobalRemoteSessionIssuerRequest,
  GetGlobalRemoteSessionIssuerSecurity,
} from "../models/operations/getglobalremotesessionissuer.js";
import {
  GetGlobalRemoteSessionIssuerDuplicatePreflightRequest,
  GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity,
} from "../models/operations/getglobalremotesessionissuerduplicatepreflight.js";
import {
  GetGlobalRemoteSessionIssuerMigratePreflightRequest,
  GetGlobalRemoteSessionIssuerMigratePreflightSecurity,
} from "../models/operations/getglobalremotesessionissuermigratepreflight.js";
import {
  ListGlobalRemoteSessionClientsRequest,
  ListGlobalRemoteSessionClientsResponse,
  ListGlobalRemoteSessionClientsSecurity,
} from "../models/operations/listglobalremotesessionclients.js";
import {
  ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest,
  ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse,
  ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity,
} from "../models/operations/listglobalremotesessionissuerconvergencecandidates.js";
import {
  ListGlobalRemoteSessionIssuersRequest,
  ListGlobalRemoteSessionIssuersResponse,
  ListGlobalRemoteSessionIssuersSecurity,
} from "../models/operations/listglobalremotesessionissuers.js";
import {
  MigrateToGlobalRemoteSessionIssuerRequest,
  MigrateToGlobalRemoteSessionIssuerSecurity,
} from "../models/operations/migratetoglobalremotesessionissuer.js";
import {
  RefreshGlobalRemoteSessionIssuerMetadataRequest,
  RefreshGlobalRemoteSessionIssuerMetadataSecurity,
} from "../models/operations/refreshglobalremotesessionissuermetadata.js";
import {
  UpdateGlobalRemoteSessionClientRequest,
  UpdateGlobalRemoteSessionClientSecurity,
} from "../models/operations/updateglobalremotesessionclient.js";
import {
  UpdateGlobalRemoteSessionIssuerRequest,
  UpdateGlobalRemoteSessionIssuerSecurity,
} from "../models/operations/updateglobalremotesessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class AdminRemoteSessions extends ClientSDK {
  /**
   * createGlobalClient adminRemoteSessions
   *
   * @remarks
   * Register a global remote_session_client under an existing global remote_session_issuer. Caller supplies client_id and optional client_secret obtained out-of-band from the upstream issuer. Requires platform admin.
   */
  async createGlobalClient(
    request: CreateGlobalRemoteSessionClientRequest,
    security?: CreateGlobalRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(adminRemoteSessionsCreateGlobalClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createGlobalIssuer adminRemoteSessions
   *
   * @remarks
   * Create a global remote_session_issuer (project_id NULL, organization_id NULL). Requires platform admin.
   */
  async createGlobalIssuer(
    request: CreateGlobalRemoteSessionIssuerRequest,
    security?: CreateGlobalRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuer> {
    return unwrapAsync(adminRemoteSessionsCreateGlobalIssuer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteGlobalClient adminRemoteSessions
   *
   * @remarks
   * Soft-delete a global remote_session_client. Cascades to the remote_sessions minted against it. Requires platform admin.
   */
  async deleteGlobalClient(
    request: DeleteGlobalRemoteSessionClientRequest,
    security?: DeleteGlobalRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(adminRemoteSessionsDeleteGlobalClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteGlobalIssuer adminRemoteSessions
   *
   * @remarks
   * Soft-delete a global remote_session_issuer. Blocked when any global remote_session_clients still reference it. Requires platform admin.
   */
  async deleteGlobalIssuer(
    request: DeleteGlobalRemoteSessionIssuerRequest,
    security?: DeleteGlobalRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(adminRemoteSessionsDeleteGlobalIssuer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * fetchGlobalIssuerMetadata adminRemoteSessions
   *
   * @remarks
   * Hit an upstream issuer's RFC 8414 .well-known/oauth-authorization-server document and return a draft suitable for createGlobalIssuer. Keyed by issuer URL; no record need exist and nothing is persisted. Requires platform admin.
   */
  async fetchGlobalIssuerMetadata(
    request: FetchGlobalRemoteSessionIssuerMetadataRequest,
    security?: FetchGlobalRemoteSessionIssuerMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuerDraft> {
    return unwrapAsync(adminRemoteSessionsFetchGlobalIssuerMetadata(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGlobalClient adminRemoteSessions
   *
   * @remarks
   * Get a global remote_session_client by id. Requires platform admin.
   */
  async getGlobalClient(
    request: GetGlobalRemoteSessionClientRequest,
    security?: GetGlobalRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(adminRemoteSessionsGetGlobalClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGlobalIssuer adminRemoteSessions
   *
   * @remarks
   * Get a global remote_session_issuer by id. Requires platform admin.
   */
  async getGlobalIssuer(
    request: GetGlobalRemoteSessionIssuerRequest,
    security?: GetGlobalRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GlobalRemoteSessionIssuer> {
    return unwrapAsync(adminRemoteSessionsGetGlobalIssuer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGlobalIssuerDuplicatePreflight adminRemoteSessions
   *
   * @remarks
   * Report the global remote_session_issuers that already describe an upstream issuer URL, so the catalog create and edit forms can warn before curating a second entry for the same authorization server. Requires platform admin.
   *
   * Scoped to the global partition only. Tenant issuers naming the same URL are deliberately not reported here — listGlobalIssuerConvergenceCandidates is the surface for those, and it is keyed on a global issuer that already exists.
   *
   * The global tier is unique on slug but not on issuer, so nothing prevents a duplicate catalog entry and this warning is the only thing that will catch one. Advisory all the same: it never blocks the write. Matching uses the same canonicalization as the tenant-facing preflights, and an unparseable URL returns no matches rather than an error.
   */
  async getGlobalIssuerDuplicatePreflight(
    request?: GetGlobalRemoteSessionIssuerDuplicatePreflightRequest | undefined,
    security?:
      | GetGlobalRemoteSessionIssuerDuplicatePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuerDuplicatePreflight> {
    return unwrapAsync(adminRemoteSessionsGetGlobalIssuerDuplicatePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGlobalIssuerMigratePreflight adminRemoteSessions
   *
   * @remarks
   * Authoritative impact summary for consolidating a tenant remote_session_issuer onto a global one: the clients that would move, the affected MCP servers, and every blocker (endpoint mismatches, conflicting MCP-server bindings). Also reports how many tenant-owned clients the target already carries, since those permanently block deleting it. Requires platform admin.
   */
  async getGlobalIssuerMigratePreflight(
    request: GetGlobalRemoteSessionIssuerMigratePreflightRequest,
    security?: GetGlobalRemoteSessionIssuerMigratePreflightSecurity | undefined,
    options?: RequestOptions,
  ): Promise<IssuerMigratePreflight> {
    return unwrapAsync(adminRemoteSessionsGetGlobalIssuerMigratePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGlobalClients adminRemoteSessions
   *
   * @remarks
   * List the global remote_session_clients registered with a global remote_session_issuer. Requires platform admin.
   */
  async listGlobalClients(
    request: ListGlobalRemoteSessionClientsRequest,
    security?: ListGlobalRemoteSessionClientsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<ListGlobalRemoteSessionClientsResponse, { cursor: string }>
  > {
    return unwrapResultIterator(adminRemoteSessionsListGlobalClients(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGlobalIssuerConvergenceCandidates adminRemoteSessions
   *
   * @remarks
   * List the organization- and project-level remote_session_issuers that describe the same upstream authorization server as a given global issuer, and so could be consolidated onto it. Matching is by canonical issuer URL, collapsing trailing-slash and default-port spellings. Each candidate carries its owning organization, the number of clients that would move, and the metadata differences that would block or accompany the migration. Requires platform admin.
   */
  async listGlobalIssuerConvergenceCandidates(
    request: ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest,
    security?:
      | ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<
      ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse,
      { cursor: string }
    >
  > {
    return unwrapResultIterator(
      adminRemoteSessionsListGlobalIssuerConvergenceCandidates(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * listGlobalIssuers adminRemoteSessions
   *
   * @remarks
   * List global remote_session_issuers. Requires platform admin.
   */
  async listGlobalIssuers(
    request?: ListGlobalRemoteSessionIssuersRequest | undefined,
    security?: ListGlobalRemoteSessionIssuersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<ListGlobalRemoteSessionIssuersResponse, { cursor: string }>
  > {
    return unwrapResultIterator(adminRemoteSessionsListGlobalIssuers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * migrateToGlobalIssuer adminRemoteSessions
   *
   * @remarks
   * Consolidate an organization- or project-level remote_session_issuer onto a global one: re-point every client from the source issuer onto the target, then soft-delete the source. Existing remote sessions are preserved, so no user re-authenticates. The source may belong to any organization; the target must be a global issuer. Both must agree on issuer (compared canonically), token_endpoint, and authorization_endpoint. One source per call. Requires platform admin.
   */
  async migrateToGlobalIssuer(
    request: MigrateToGlobalRemoteSessionIssuerRequest,
    security?: MigrateToGlobalRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<MigrateRemoteSessionIssuerResult> {
    return unwrapAsync(adminRemoteSessionsMigrateToGlobalIssuer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * refreshGlobalIssuerMetadata adminRemoteSessions
   *
   * @remarks
   * Re-fetch an existing global remote_session_issuer's RFC 8414 metadata document and persist the discovered values. Keyed by issuer id. Only RFC 8414-derived columns are written — endpoints, the *_supported arrays, client_id_metadata_document_supported, and the documentation URLs. Speakeasy behavior and display fields (oidc, passthrough, name, slug, logo, client setup documentation) are left alone. Requires platform admin.
   */
  async refreshGlobalIssuerMetadata(
    request: RefreshGlobalRemoteSessionIssuerMetadataRequest,
    security?: RefreshGlobalRemoteSessionIssuerMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuerRefresh> {
    return unwrapAsync(adminRemoteSessionsRefreshGlobalIssuerMetadata(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateGlobalClient adminRemoteSessions
   *
   * @remarks
   * Rotate the client_secret or change non-issuer settings on a global remote_session_client. Requires platform admin.
   */
  async updateGlobalClient(
    request: UpdateGlobalRemoteSessionClientRequest,
    security?: UpdateGlobalRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(adminRemoteSessionsUpdateGlobalClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateGlobalIssuer adminRemoteSessions
   *
   * @remarks
   * Update a global remote_session_issuer. Requires platform admin.
   */
  async updateGlobalIssuer(
    request: UpdateGlobalRemoteSessionIssuerRequest,
    security?: UpdateGlobalRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuer> {
    return unwrapAsync(adminRemoteSessionsUpdateGlobalIssuer(
      this,
      request,
      security,
      options,
    ));
  }
}
